import { render, staticRenderFns } from "./TableCellFioPost.vue?vue&type=template&id=479aa972&"
import script from "./TableCellFioPost.vue?vue&type=script&lang=ts&"
export * from "./TableCellFioPost.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports